import Axios from 'axios';
// import {DynamicColorIOS} from 'react-native/Libraries/StyleSheet/PlatformColorValueTypesIOS';
import { getHeaders } from '../../utills';
import CustomerActions from '../Actions/CustomerActions';
import JobDetailsActions from '../Actions/JobDetailsActions';
import GeneralAction from '../Actions/GeneralAction';
import Apis from '../Apis';
import AlertAction from '../Actions/AlertActions';

// import {Alert} from 'react-native';

class CustomerMiddleware {
  static getCreateCustomer = userData => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const formdata = new FormData()
          if (userData?.next_page_url == undefined) {
            dispatch(CustomerActions.clearCreateCustomer());
          }
          if (userData.search) formdata.append('name', userData?.search);
          const { data } = await Axios.post(
            Apis.customers(userData?.next_page_url),
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            dispatch(CustomerActions.getCreateCustomer(data?.data));
            resolve(data?.data)
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))

          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static CreateCustomer = userData => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('first_name', userData?.Firstname);
          formdata.append('last_name', userData?.Lastname);
          formdata.append('email', userData?.Email);
          formdata.append('contact_no', userData?.ContactNumber);
          formdata.append('company_id', userData?.company_id);
          formdata.append('address', userData?.Address);
          formdata.append('lat', userData?.Lat);
          formdata.append('lng', userData?.Lng);
          // for (const [i, document] of userData?.MultipleAddress.entries()) {
          //   formdata.append(`addresses[${i}][street]`, document?.Street);
          //   formdata.append(`addresses[${i}][state]`, document?.State);
          //   formdata.append(`addresses[${i}][zipcode]`, document?.ZipCode);
          // }
          const { data } = await Axios.post(
            Apis.customersCreate,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data);
            dispatch(CustomerMiddleware.getCreateCustomer(userData));
            dispatch(GeneralAction.HideLoading());
          } else {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))

          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static getJobDetails = userData => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (userData?.next_page_url == undefined) {
            dispatch(JobDetailsActions.clearJobDetails());
          }
          const { data } = await Axios.post(
            Apis.jobs(userData?.next_page_url),
            {},
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data);
            dispatch(JobDetailsActions.getJobDetails(data?.data));
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))

          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static CreateJob = userData => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (userData?.WorkOrderRequestId) {
            formdata.append('work_request_id', userData?.WorkOrderRequestId)
          }
          // {userData?.WorkOrderRequestId ? formdata.append('work_request_id', userData?.WorkOrderRequestId) : null}
          formdata.append('category_id', userData?.SelectedCategory);
          formdata.append('date', userData?.SelectedDate);
          formdata.append('start_time', userData?.StartTime);
          formdata.append('end_time', userData?.EndTime);
          if (userData?.StoreID) {
            formdata.append('store_id', userData?.StoreID)
          }
          // {userData?.StoreID ? formdata.append('store_id', userData?.StoreID) : null}
          formdata.append('urgency', userData?.SelectedUrgency);
          if (userData?.LocationID) {
            formdata.append('store_address_id', userData?.LocationID)
          }
          // {userData?.LocationID ? formdata.append('store_address_id', userData?.LocationID) : null};          
          formdata.append('service_name', userData?.ServiceName);
          formdata.append('details', userData?.ServiceDetails);
          formdata.append('customer_id', userData?.SelectedCustomer);
          formdata.append('address_id', userData?.selectedLocation);
          formdata.append('lunch_start_time', userData?.LunchStartTime);
          formdata.append('lunch_end_time', userData?.LunchEndTime);
          formdata.append('cleaner_id', userData?.SelectedCleaner);
          formdata.append('shift', userData?.SelectedShift);
          if (userData?.SelectedInventory?.length > 0) {
            for (const [i, document] of userData?.SelectedInventory.entries()) {
              formdata.append(`inventories[${i}][inventory_id]`, document?.id);
              formdata.append(`inventories[${i}][quantity]`, document?.quantity);
            }
          }

          const { data } = await Axios.post(
            Apis.jobsCreate,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data);
            dispatch(CustomerMiddleware.getJobDetails(userData));
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))

            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))

          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static getUsersByRole = userData => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('role', userData?.role);
          const { data } = await Axios.post(
            Apis.getUsersByRole,
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))

          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static cleanersJobLocations = userData => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('cleaner_id', userData?.id);
          formdata.append('pagination', userData?.pagination);
          const { data } = await Axios.post(
            Apis.getJobsByCleanerId(userData?.next_page_url),
            formdata,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))

          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static CreateChecklist = userData => {
    console.log('Input Array ===========', userData);
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append('name', userData?.CheckListName);
          formdata.append('job_id', userData?.Id);
          for (const [i, item] of userData?.data?.entries()) {
            formdata.append(`items[${i}][name]`, item.itemName);
            formdata.append(`items[${i}][description]`, item.description);
            if (item?.image) {
              formdata.append(`items[${i}][attachment]`, item.image)
            }
            // {
            //   item?.image
            //     ? formdata.append(`items[${i}][attachment]`, item.image)
            //     : null;
            // }
          }
          const { data } = await Axios.post(
            Apis.checklistCreate,
            formdata,
            {
              headers: getHeaders()
            }
          );
          console.log('===================', data);
          if (data?.success) {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          } else {
            resolve(data);
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))

          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };

  static CustomerDashboard = () => {
    return dispatch => {
      dispatch(GeneralAction.ShowLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Axios.get(
            Apis.customerDashboard,
            {
              headers: getHeaders()
            }
          );
          if (data?.success) {
            // console.log('This is the data : ', data);
            resolve(data?.data);
            dispatch(GeneralAction.HideLoading());
          } else {
            dispatch(GeneralAction.HideLoading());
          }
        } catch (error) {
          reject(error);
          dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))

          console.log(error);
          dispatch(GeneralAction.HideLoading());
        }
      });
    };
  };
}

export default CustomerMiddleware;
